import '../math/Graph.js';
import { Point } from '../math/Shapes.js';

class PositionAdapter {
    constructor(layoutState) {
        this.layoutState = layoutState;
        this.diagram = layoutState.diagram;
    }
    initState() {
        this.froms = [];
        this.tos = [];
        this.subjects = [];
        const pusher = (id, bounds) => {
            const shape = this.diagram.getShapeById(id);
            if (shape) {
                this.subjects.push(shape);
                this.froms.push(shape.bounds().topLeft());
                this.tos.push(bounds.topLeft());
            }
        };
        this.layoutState.nodeMap.forEach(pusher, this);
    }
    update(tick) {
        if (this.subjects.length <= 0) {
            return;
        }
        for (let i = 0; i < this.subjects.length; i++) {
            // todo: define a Lerp function instead
            this.subjects[i].position(new Point(this.froms[i].x + (this.tos[i].x - this.froms[i].x) * tick, this.froms[i].y + (this.tos[i].y - this.froms[i].y) * tick));
        }
    }
}

export { PositionAdapter };
